var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuelaughter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2803 11.0973C18.4929 6.57208 15.8074 1.92068 11.2821 0.70814C6.75674 -0.504399 2.10527 2.18109 0.892714 6.70635C-0.319841 11.2316 2.36568 15.883 6.891 17.0955C11.4163 18.3081 16.0678 15.6226 17.2803 11.0973Z",
    fill: "url(#paint0_linear_2850_22432)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2688 7.45337C14.9409 8.74793 15.0133 10.2132 14.5804 11.5079C14.1883 12.6734 13.3868 13.7038 12.2416 14.365C11.0963 15.0262 9.80318 15.2052 8.59777 14.9619C7.25997 14.6893 6.02729 13.8941 5.24219 12.6648C6.25717 11.5864 7.70366 10.455 9.41399 9.46759C11.1243 8.48014 12.8274 7.79327 14.2688 7.45337Z",
    fill: "url(#paint1_linear_2850_22432)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5804 11.5079C14.1883 12.6734 13.3868 13.7038 12.2416 14.365C11.0963 15.0262 9.80318 15.2052 8.59777 14.9619C8.98971 13.7962 9.79132 12.766 10.9366 12.1047C12.0818 11.4435 13.3749 11.2645 14.5804 11.5079Z",
    fill: "url(#paint2_linear_2850_22432)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61602 10.731C4.49426 10.8013 4.34085 10.8114 4.20532 10.7445C3.98986 10.6377 3.90172 10.3771 4.00811 10.1617C4.42428 9.32008 5.03299 8.5434 5.48316 8.02686C4.80334 7.97692 3.87245 7.94534 3.24491 7.93484C3.00469 7.9308 2.81339 7.73269 2.81743 7.49247C2.82134 7.25232 3.01951 7.06082 3.25973 7.06486C3.52471 7.06937 5.86753 7.11334 6.49529 7.28155C6.6469 7.32217 6.76452 7.4411 6.80374 7.59262C6.84308 7.74407 6.79806 7.9055 6.6854 8.01412C6.67292 8.02619 5.44041 9.22831 4.78811 10.5472C4.74849 10.6269 4.68778 10.6896 4.61602 10.731Z",
    fill: "#26304E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9006 5.94608C13.0224 5.87578 13.1078 5.74797 13.1176 5.59714C13.1329 5.35719 12.9513 5.15055 12.7115 5.13496C11.7746 5.07458 10.7976 5.21339 10.1253 5.3449C10.422 4.73119 10.8601 3.90924 11.1647 3.36054C11.2813 3.15048 11.2054 2.88575 10.9954 2.76914C10.7854 2.65246 10.5205 2.72832 10.4039 2.93838C10.2753 3.1701 9.14198 5.22101 8.97377 5.84876C8.93315 6.00036 8.97733 6.16169 9.08895 6.27141C9.20044 6.3812 9.36275 6.42293 9.51316 6.37968C9.52985 6.37491 11.1872 5.90859 12.6556 6.00317C12.7444 6.00868 12.829 5.98744 12.9008 5.94601L12.9006 5.94608Z",
    fill: "#26304E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8759 5.36059C18.8627 5.64354 19.4331 6.67282 19.1502 7.65943C18.8673 8.64604 17.8379 9.2166 16.8513 8.9337C15.8647 8.65079 13.3438 5.99449 13.3438 5.99449C13.3438 5.99449 16.8893 5.07769 17.8759 5.36059Z",
    fill: "url(#paint3_linear_2850_22432)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63781 16.0343C4.35485 17.021 3.32556 17.5914 2.33894 17.3085C1.35231 17.0256 0.781742 15.9963 1.06465 15.0097C1.34756 14.0231 4.0039 11.5022 4.0039 11.5022C4.0039 11.5022 4.92072 15.0477 4.63781 16.0343Z",
    fill: "url(#paint4_linear_2850_22432)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2850_22432",
    x1: 4.80882,
    y1: 1.49286,
    x2: 13.2915,
    y2: 16.1855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDCB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2850_22432",
    x1: 10.0469,
    y1: 7.42078,
    x2: 10.0469,
    y2: 15.0332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D4C1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2850_22432",
    x1: 10.931,
    y1: 12.0952,
    x2: 12.236,
    y2: 14.3556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6486A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DE274D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD192B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2850_22432",
    x1: 13.3623,
    y1: 5.99973,
    x2: 19.1688,
    y2: 7.66476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1081D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2EB4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#26B4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67D6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2850_22432",
    x1: 3.99858,
    y1: 11.5207,
    x2: 2.33362,
    y2: 17.3272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1081D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2EB4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#26B4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67D6FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuelaughter);
export default __webpack_public_path__ + "static/media/valuelaughter.722c1d8552108e8d6efb4dc7aa011b61.svg";
export { ForwardRef as ReactComponent };